module.exports = __webpack_public_path__ + "img/usacli-logo.f84bb69b.jpg";